import React from 'react'
import PropTypes from 'prop-types'

import VideoPlayerContext from './VideoPlayerContext'
import VideoPlayerLayout from './VideoPlayerLayout'

const VideoPlayerLite = ({ src, type, poster, ...rest }) => {
  return (
    <VideoPlayerContext src={src} type={type} poster={poster}>
      <VideoPlayerLayout {...rest} />
    </VideoPlayerContext>
  )
}

VideoPlayerLite.propTypes = {
  src: PropTypes.string.isRequired,
  type: PropTypes.string,
  poster: PropTypes.string
}

export default VideoPlayerLite
